module.exports = __webpack_public_path__ + "img/en.f98afe9e.svg";